export const BUILD_INFO = { sha: '3c9dd27' };
